module.exports = "/images/vendor/desiigner-svg/svg/places/party.svg?76b6d33d4f5ade21d81b6c06ae96a4e2";